import classes from "./Layout.module.css";
import Header from "../Header/Header";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Trading from "../Trading/Trading";
import Tabs from "../Tabs/Tabs";
import PayoutPool from "../PayoutPool/PayoutPool";
import Profile from "../Profile/Profile";
import Refer from "../Refer/Refer";
import { env } from "../../constants/env";
import PaymentCompleted from "../PurchaseOptions/PaymentCompleted";
import PaymentCancelled from "../PurchaseOptions/PaymentCancelled";

const Layout = () => {
  const location = useLocation();
  return (
    <div className={classes.wrapper}>
      <Header />
      <div className={`row d-flex justify-content-center mx-0`}>
        <div className={`col-lg-11 col-12`}>
        {location.pathname !== "/refer" && <>
          {/* <h1>Beta Portal</h1> */}
          <Tabs />
          </>}
          <div className={`${classes.content}`}>
            <Routes>
              <Route path="/" element={<Navigate to="/trading" />} />
              <Route path="/trading" element={<Trading />} />
              <Route path="/payout-pool" element={<PayoutPool />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/refer" element={<Refer />} />
              <Route path="/payment-complete" element={<PaymentCompleted />} />
              <Route path="purchase-cancel" element={<PaymentCancelled />} />
            </Routes>
          </div>
        </div>
      </div>
      <div className={`${classes.footer} d-flex justify-content-end`}> <a href={`${env.siteUrl}/terms`} target="_blank"><button>Terms of service</button></a></div>
    </div>
  );
};

export default Layout;
